module.exports = __webpack_public_path__ + "static/media/map.f78e652b.png";